import { ProductOutlined } from '@ant-design/icons'
import { type ReactNode, Suspense, useState } from 'react'

import { useUserInfoStore } from '@/stores/user/userInfoStore'
import type { NomenclatureExtendedInterface } from '@/types'
import { safeLazy } from '@/utils/app/safeLazy'
import { focusProductSearchInput } from '@/utils/search/ui/focusProductSearchInput'

import cn from './ProductInfo.module.scss'

const ProductInfoModal = safeLazy(
  () => import('./ProductInfoModal/ProductInfoModal')
)

type ProductInfoPropsType = {
  product: NomenclatureExtendedInterface
  children?: ReactNode
}

let preloadPromise: Promise<
  typeof import('./ProductInfoModal/ProductInfoModal')
> | null = null

function preloadModal() {
  if (!preloadPromise) {
    preloadPromise = import('./ProductInfoModal/ProductInfoModal')
  }
  return preloadPromise
}

function ProductInfo({ product, children }: ProductInfoPropsType) {
  const [open, setOpen] = useState(false)
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )

  const handleOpen = async () => {
    await preloadModal()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    focusProductSearchInput(350)
  }

  return (
    <>
      {children ? (
        <button
          type="button"
          className={[
            cn.imageTrigger,
            isOrganisationSelected ? cn.organisationSelected : '',
          ].join(' ')}
          onMouseEnter={preloadModal}
          onClick={handleOpen}
          aria-label="Открыть информацию о товаре"
        >
          {children}
        </button>
      ) : (
        <div
          className={cn.cell}
          onMouseEnter={preloadModal}
          onClick={handleOpen}
        >
          <ProductOutlined />
        </div>
      )}

      {open && (
        <Suspense fallback={null}>
          <ProductInfoModal
            product={product}
            open={open}
            onClose={handleClose}
          />
        </Suspense>
      )}
    </>
  )
}

export default ProductInfo
